import { IStaffInfo, PatchedTypes } from "messages";
import React, { Fragment, FunctionComponent } from "react";

import { Button, CircularProgress, DialogActions, DialogContent, DialogTitle, List } from "@material-ui/core";

import { ThemedStyledProps } from "styled-components";
import styled from "../../styles/styled-components";
import { ITheme } from "../../styles/theme";
import { AlertDialog } from "../AlertDialog";
import { ServiceRequestListItem } from "../ServiceRequestListItem";
import { EscalationTimeline } from "../Timeline";

const ProgressWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  color: ${(props: ThemedStyledProps<{}, ITheme>) => props.theme.colorPalette.ordaapRed} !important;
`;

export interface IEscalationExpansionModalProps {
  actionButtonLabel?: string;
  closeButtonLabel?: string;
  children: JSX.Element;
  isLoading: boolean;
  request: PatchedTypes.IServiceRequest;
  escalationRequest: PatchedTypes.IServiceRequestEscalation;
  allStaffInfoMap: Map<string, IStaffInfo>;
  title: string;
  handleAccept(handleClose: () => void): void;
  handleDecline(handleClose: () => void): void;
  handleThumbnailClick?(images: string[], index: number): void;
}

const EscalationExpansionModal: FunctionComponent<IEscalationExpansionModalProps> = (
  props: IEscalationExpansionModalProps
) => {
  const {
    actionButtonLabel,
    closeButtonLabel,
    children,
    handleAccept,
    handleDecline,
    handleThumbnailClick,
    isLoading,
    request,
    title,
    escalationRequest,
    allStaffInfoMap
  } = props;

  return (
    <AlertDialog
      render={({ handleClose }) => (
        <Fragment>
          <DialogTitle>{isLoading ? "Please wait" : title}</DialogTitle>
          <DialogContent>
            {!isLoading && children}
            {!isLoading && (
              <List dense>
                <ServiceRequestListItem handleThumbnailClick={handleThumbnailClick} defaultFullInfo request={request} />
              </List>
            )}
            {!isLoading && <EscalationTimeline request={request} escalationDetails={escalationRequest} />}
            {isLoading && (
              <ProgressWrapper>
                <CircularProgress color="inherit" />
              </ProgressWrapper>
            )}
          </DialogContent>
          {!isLoading && (
            <DialogActions>
              <Button variant="contained" color="secondary" onClick={() => handleDecline(handleClose)}>
                {closeButtonLabel || "CANCEL"}
              </Button>
              {actionButtonLabel && (
                <Button variant="contained" color="primary" onClick={() => handleAccept(handleClose)}>
                  {actionButtonLabel}
                </Button>
              )}
            </DialogActions>
          )}
        </Fragment>
      )}
    />
  );
};

export default EscalationExpansionModal;
